import { render, staticRenderFns } from "./ExplanationDialog.vue?vue&type=template&id=532d341d&lang=pug"
import script from "./ExplanationDialog.vue?vue&type=script&lang=js"
export * from "./ExplanationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports